<template>
    <v-container fluid class="pa-0 mb-offset">
        <v-row class="ma-0">
            <revenue-chart
                title="Fatturato Attivo / Passivo"
                entity-title="Confronto fatturato emesso vs ricevuto"
                url="edocuments-statistics"
                balloon-text="[[category]] - [[title]]: <b>[[value]] €</b>"
                comparison-type="difference"
                comparison-label="Margine (Attivo - Passivo)"
            ></revenue-chart>
        </v-row>
    </v-container>
</template>

<script>
import RevenueChart from '@/components/common/RevenueChart'

export default {
    name: 'edocument-statistics',
    components: {
        RevenueChart,
    },

    created() {
        this.$store.commit('endProgress')
    }
}
</script>
